import { ITicket } from '@nkr/models/index';
import { Table } from 'react-bootstrap';

interface IProps {
    ticket: ITicket
}

const ContactInfo = (props: IProps) => {
    if (props.ticket == null)
        return null;

    const { contact } = props.ticket;

    return (
        <>
            <div className='row' style={{ marginBottom: 10 }}>
                <div className='col-xs-12 col-lg-12' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 45, fontSize: 16, fontWeight: 600, borderTopLeftRadius: 4, borderTopRightRadius: 4 }}>
                    <div>CONTACT DETAILS</div>
                </div>
            </div>

            <div style={{ marginBottom: 20 }}>
                <label>Full Name</label>
                <div className='form-control' style={{ backgroundColor: '#eee' }}>{contact.fullName}</div>
            </div>

            <div style={{ marginBottom: 20 }}>
                <label>Email</label>
                <div className='form-control' style={{ backgroundColor: '#eee', wordBreak: 'break-all' }}>{contact.email}</div>
            </div>

            <div style={{ marginBottom: 20 }}>
                <label>Phone Numbers</label>
                <div>
                    {contact.phoneNumbers.length > 0 ?
                        <Table bordered condensed>
                            <thead>
                                <tr>
                                    <th>Number</th>
                                    <th>Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contact.phoneNumbers.filter(x => x.isDeleted == false).map(ph =>
                                    <tr>
                                        <td>{ph.number}</td>
                                        <td>{ph.phoneTypeName}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        :
                        <div>[No phone numbers...]</div>
                    }
                </div>
            </div>
        </>
    );
}

export default ContactInfo;